import { PUT_AGREEMENT } from './action';
import agreement from '../../translations/pl_PL/blog/agreement.json';

function agreementReducer(state=agreement, action)
{
    switch (action.type) {
      case PUT_AGREEMENT:
        return action.payload;

      default:
        return state;
  }
}

export default agreementReducer;
